import React, { FC, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, fetchFormData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddRestaurantHeader } from './AddRestaurantHeader';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import imageCompression from 'browser-image-compression';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddRestaurantPhotos: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editRestaurantId = (location.state as any)?.restaurantId || '';

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const inputfileRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [inputImage, setInputImage] = useState([]) as any;
    const [uploadedImage, setUploadedImage] = useState([]);
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    // set error state
    const [error, setError] = useState([{
        subCategoryId: '',
        amenityId: '',
        hotelClass: '',
        hotelNameEN: '',
        contactPersonName: '',
        email: '',
        phoneNumber: '',
        descriptionEN: '',
        address: '',
        serviceLanguage: '',
        inputImage: ''
    }])

    const handleTextClick = () => {

        let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement;
        element.click();

    };
    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    const handleImageChange = async (e: any) => {
        removeError("inputImage");
        const selectedFiles = Array.from(e.target.files);
        const validFiles = selectedFiles.filter((file: any) => {
            if (file.size > 5 * 1024 * 1024) { // 5 MB = 5 * 1024 * 1024 bytes
                toasterrormsg(`${file.name} is larger than 5 MB and was not added.`);
                return false;
            }
            return true;
        });
        const MAX_IMAGES = 15;
        // Check if adding selected files will exceed the limit
        if (inputImage.length + validFiles.length > MAX_IMAGES) {
            // If it exceeds, only select files up to the limit
            const remainingCapacity = MAX_IMAGES - inputImage.length;
            const limitedFiles = validFiles.slice(0, remainingCapacity);

            // Display a message or perform an action to notify the user about the limit
            toasterrormsg(t(`Maximum ${MAX_IMAGES} images can be uploaded.`));

            // Compress the images
            const processedFiles = await Promise.all(
                limitedFiles.map((file: any) => processImage(file))
            );

            // Store the processed file names as paths
            const filePaths = processedFiles.map((file) => file);

            // Append new images to the existing array of images
            setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
        } else {
            // If it doesn't exceed, proceed as before
            const processedFiles = await Promise.all(
                validFiles.map((file: any) => processImage(file))
            );
            const filePaths = processedFiles.map((file) => file);
            setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
        }
    };

    const processImage = async (imageFile: File) => {
        if (imageFile.size >= 2 * 1024 * 1024) {
            return await compressImage(imageFile);
        } else {
            return imageFile;
        }
    };

    const compressImage = async (imageFile: File) => {
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1024,
            useWebWorker: true
        };
        try {
            const compressedBlob = await imageCompression(imageFile, options);
            const extension = imageFile.name.split('.').pop();
            const newFileName = `${Date.now()}.${extension}`;
            const compressedFile = new File([compressedBlob], newFileName, {
                type: compressedBlob.type,
                lastModified: Date.now()
            });
            return compressedFile;
        } catch (error) {
            console.error('Error compressing image:', error);
            return imageFile;
        }
    };

    const handleDragEnd = (result: any) => {
        if (!result.destination) return; // dropped outside the list
        const items = Array.from(inputImage);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setInputImage(items);

    };

    // function for remove selected images
    const handleRemove1 = (index1: any) => {

        let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)
        setInputImage(tmparrimg);

    };

    // remove uplaoded images
    const handleRemoveImage = async (index: any) => {

        var param = {
            'restaurantmediaId': index
        }
        var res = await fetchData("public/deleteRestaurantMedia", param)

        if (res.status == "200") {
            restaurantDetailApiCall()
        }
        else {
            toasterrormsg(res.message)
        }
    };
    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (uploadedImage.length < 2) {

            if (inputImage.length == 0) {
                errorTmp[0].inputImage = t('Images Is Required');
                isValid = false;
            } else if (inputImage.length < 2) {
                errorTmp[0].inputImage = t('Minimum 3 Images Is Required');
                isValid = false;
            }
        }
        setError(errorTmp);
        return isValid;
    }

    // add restaurant images api call
    const addRestaurantImageApi = async () => {
        if (validate()) {

            setDisable(true)
            setLoading(true);
            let param = new FormData()
            param.append('restaurantId', editRestaurantId)
            if (inputImage.length != 0) {
                inputImage.forEach((file: any) => {
                    param.append('image', file);
                });
            }
            var res = await fetchFormData("public/addResturantImage", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Images Added Successfully!"))
                const state = {
                    restaurantId: editRestaurantId
                }
                setTimeout(() => {
                    navigate("../addrestaurantfacilities/", { state });
                    setDisable(false)
                }, 1500);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)
            }
        }
    }
    //   restaurant list api call
    const restaurantDetailApiCall = async () => {

        var param = {
            'vendorId': vendorId,
            'restaurantId': editRestaurantId
        }
        var res = await fetchData("public/restaurantDetail", param)

        if (res.status == "200") {
            var restaurantData = res.data;
            setRestaurantDetails(restaurantData);
            setUploadedImage(restaurantData[0].images)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {

        if (editRestaurantId != "") {
            restaurantDetailApiCall();
        }
    }, [])

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Property Photos') : t('Add Property Photos')}</PageTitle>
            <AddRestaurantHeader restaurantId={editRestaurantId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Property Photos')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        restaurantDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    restaurantDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['menu']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {/* <!--begin::Label--> */}
                                                <label className="fs-4 form-label">{t('Upload images')}</label>
                                                {/* <!--end::Label--> */}
                                                <br />
                                                <input
                                                    ref={inputfileRef}
                                                    style={{ display: 'none' }}
                                                    className='modaldocument'
                                                    type='file'
                                                    onChange={handleImageChange}
                                                    accept='image/*'
                                                    multiple
                                                />
                                                <span className='btn btn-light text-primary cursor-pointer ' onClick={handleTextClick}> {t('Attach Images')}</span>
                                                <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                                                <div className="row mt-3">
                                                    {uploadedImage ? (
                                                        uploadedImage.map((imageList, index) => (

                                                            <div className="col-lg-2 col-4 d-flex flex-column mb-5" key={index} >
                                                                <button
                                                                    className="btn btn-danger p-1 px-2 rounded-circle"
                                                                    style={{
                                                                        width: '20px', // Adjust to your preferred size
                                                                        height: '20px',
                                                                        fontSize: '12px',
                                                                        alignSelf: 'end',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        position: 'relative',
                                                                        top: '7%',
                                                                        right: '-3%'
                                                                    }}
                                                                    onClick={() => handleRemoveImage(imageList['restaurantmediaId'])}
                                                                >
                                                                    X
                                                                </button>
                                                                <div style={{ maxWidth: "fit-content" }} className="p-2 shadow rounded-1">
                                                                    <img src={imageList['mediaPath']} width="100%" className='rounded-1' />
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : ""}
                                                </div>
                                                <DragDropContext onDragEnd={handleDragEnd}>
                                                    <Droppable droppableId="imageList">
                                                        {(provided: any) => (
                                                            <div className="row mt-3" {...provided.droppableProps} ref={provided.innerRef}>
                                                                {inputImage &&
                                                                    inputImage.map((imageList: any, index: any) => (
                                                                        <Draggable key={index} draggableId={`image-${index}`} index={index}>
                                                                            {(provided: any) => (
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    className="col-lg-2 col-4 d-flex flex-column mb-5"
                                                                                >
                                                                                    <button
                                                                                        className="btn btn-danger p-1 px-2 rounded-circle"
                                                                                        style={{
                                                                                            width: '20px', // Adjust to your preferred size
                                                                                            height: '20px',
                                                                                            fontSize: '12px',
                                                                                            alignSelf: 'end',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            position: 'relative',
                                                                                            top: '7%',
                                                                                            right: '-3%'
                                                                                        }}
                                                                                        onClick={() => handleRemove1(index)}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                    <div style={{ maxWidth: "fit-content" }} className="p-2 shadow rounded-1">
                                                                                        <img src={URL.createObjectURL(imageList)} width="100%" className='rounded-1' />
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>

                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addRestaurantImageApi}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddRestaurantPhotos }
